<ul class="HeaderLinks">
  @if (showLanguageSelectorDropdown() && languages() && languagesCount() > 1) {
    <li class="login">
      <cx-generic-link [class]="'lnk-world'" aria-haspopup="true"></cx-generic-link>

      <div>&nbsp;&nbsp;{{ activeLang() | uppercase }}</div>
      <div class="dropdown-menu">
        @for (lang of languages(); track lang) {
          <button class="btn-dropDownMenu btn-block" type="submit" (click)="setLanguage(lang.isocode)">
            {{ lang.nativeName }}
          </button>
        }
      </div>
    </li>
  }
  @if (showMyAccountDropdown()) {
    <li class="login">
      <cx-generic-link [url]="'/login'" [class]="'lnk-user'">
        <span class="sr-only">{{ 'myAccount.login' | cxTranslate }}</span>
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
          <path
            d="M12 22.03a9.99 9.99 90 007.15-3 7.62 7.62 90 00-14.3 0 9.99 9.99 90 007.15 3Zm0-8.93a3.04 3.04 90 003.03-3.03A3.03 3.03 90 1012 13.1ZM12 1.97A10.02 10.02 90 004.15 18.24a8.53 8.53 90 015.67-4.85 3.97 3.97 90 114.36 0 8.53 8.53 90 015.67 4.85A10.02 10.02 90 0012 1.97Zm0-.94A10.98 10.98 90 0122.97 12 10.97 10.97 90 1112 1.03Z"
          />
        </svg>
      </cx-generic-link>
      <div class="dropdown-menu">
        @if (isLoggedIn()) {
          @if (!cdcEnabled()) {
            <cx-generic-link [url]="'/my-account/update-email'">
              {{ 'myAccount.updateEmail' | cxTranslate }}
            </cx-generic-link>
          }
          @if (!cdcEnabled()) {
            <cx-generic-link [url]="'/my-account/update-password'">
              {{ 'myAccount.updatePassword' | cxTranslate }}
            </cx-generic-link>
          }
          <cx-generic-link [url]="'/my-account/update-profile'">
            {{ 'myAccount.personalDetails' | cxTranslate }}
          </cx-generic-link>
          @if (!cdcEnabled()) {
            <cx-generic-link [url]="'/my-account/address-book'">
              {{ 'myAccount.addressBook' | cxTranslate }}
            </cx-generic-link>
          }
          @if (showOrderHistoryMenuNode()) {
            <cx-generic-link [url]="'/my-account/orders'">
              {{ 'myAccount.orderHistory.orderHistory' | cxTranslate }}
            </cx-generic-link>
          }
          @if (subscriptions()) {
            <cx-generic-link [url]="'/my-account/subscriptions'">
              {{ 'myAccount.subscriptions' | cxTranslate }}
            </cx-generic-link>
          }
          @if (showLufcMembershipMenuNode()) {
            <cx-generic-link [url]="lufcMembershipUrl()">
              {{ 'myAccount.lufcMembership' | cxTranslate }}
            </cx-generic-link>
          }
          <cx-generic-link [url]="'/my-account/consents'">
            {{ 'myAccount.consents' | cxTranslate }}
          </cx-generic-link>
          <cx-generic-link [url]="'/logout'">{{ 'myAccount.logout' | cxTranslate }}</cx-generic-link>
        } @else {
          <cx-generic-link [url]="'/login'">{{ 'myAccount.login' | cxTranslate }}</cx-generic-link>
        }
      </div>
    </li>
  }
  @if (showAddToCartButtonAndCartMenuNode()) {
    <li class="cart">
      <cx-generic-link [class]="'lnk-cart-counter'" [url]="'/cart'">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
          <title>{{ 'pageMetaResolver.cart.title' | cxTranslate }}</title>
          <path
            d="M19 23a2 2 90 112-2 2 2 90 01-2 2Zm0-3a1 1 90 101 1 1 1 90 00-1-1Zm-9 3a2 2 90 112-2 2 2 90 01-2 2Zm0-3a1 1 90 101 1 1 1 90 00-1-1Zm10.58-2h-12a1.25 1.25 90 01-1.21-.93L3.66 2.18A.25.25 90 003.42 2H0V1H3.42a1.25 1.25 90 011.21.93L5.66 6H23a1.25 1.25 90 011 1.55L21.8 17a1.23 1.23 90 01-1.22 1ZM5.91 7 8.4 16.82a.25.25 90 00.24.18h12a.25.25 90 00.24-.19L23 7.34a.25.25 90 000-.22.26.26 90 00-.2-.13Z"
          />
          @if (cartItemCount() > 0) {
            <ng-container>
              <circle r="7" cx="15" cy="7"></circle>
              <text x="15" y="7" text-anchor="middle" dominant-baseline="central" fill="Canvas" stroke="Canvas">
                {{ cartItemCount() }}
              </text>
            </ng-container>
          }
        </svg>
      </cx-generic-link>
    </li>
  }
  <li class="search">
    <cx-searchbox></cx-searchbox>
  </li>
  <li class="hamburger">
    <nav>
      <cx-hamburger-menu></cx-hamburger-menu>
    </nav>
  </li>
</ul>
